import 'Layouts/default';

import 'Ui/tabs';

Event.on('Finstat.select.after', (autocompleteField, data) => {
    const form = autocompleteField.closest('form')
    const billing = form.querySelector('.js-b2b-reg-billing')

    if (billing) {
        billing.classList.remove('h-nodisplay')

        if (Object.values(data.result || []).length) {
            for (const input of billing.querySelectorAll('input, select')) {
                $(input).valid()
            }
        }
    }
})
